import * as Sentry from '@sentry/react';
import posthog from 'posthog-js';
import { getMarketBasedOnHostname } from '~/helpers/utils';

const {
  VITE_SENTRY_ENABLED,
  VITE_SENTRY_DSN_URL,
  VITE_SENTRY_PROJECT_ID,
  MODE,
  VITE_CURRENT_VERSION,
} = import.meta.env;

if (VITE_SENTRY_ENABLED === 'true') {
  Sentry.init({
    dsn: `${VITE_SENTRY_DSN_URL}/${VITE_SENTRY_PROJECT_ID}`,
    integrations: [
      new posthog.SentryIntegration(posthog, 'qred', VITE_SENTRY_PROJECT_ID),
    ],
    environment: MODE,
    release: VITE_CURRENT_VERSION,
    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 0.2,
    normalizeDepth: 10,
    beforeBreadcrumb(breadcrumb, hint) {
      if (breadcrumb.category === 'xhr') {
        breadcrumb.data = {
          ...breadcrumb.data,
          response: JSON.parse((hint?.xhr as XMLHttpRequest).response),
        };
      }
      return breadcrumb;
    },
    beforeSend(event) {
      try {
        event.tags = {
          ...event.tags,
          market: getMarketBasedOnHostname(),
        };
        return event;
      } catch (error) {
        console.error('Error in beforeSend', error);
        return event;
      }
    },
  });
}

export { Sentry };
